import { bottomDrawerHelperActions } from 'src/components/20-helper-views/bottom-drawer/useBottomDrawer';
import { overlayHelperViewActions } from 'src/components/20-helper-views/overlay/useOverlay';
import Analytics from 'src/lib/analytics';
import Crashlytics from 'src/lib/crashlytics';
import { getDeviceInfo } from 'src/lib/device';
import FTUEStorage from 'src/lib/ftue/storage';
import { graphqlClient } from 'src/lib/graphql';
import { getJSONStorage, UNSAFE_clearAllStorages } from 'src/lib/storage';
import StorageKeys from 'src/lib/storage/storageKeys';
import { StorageScope } from 'src/lib/storage/types';
import { getTenancy } from 'src/modules/debug/utils';
import { Tenancy } from 'src/modules/debug/types';
import isShallowEqual from 'src/utils/object/isShallowEqual';
import { isBrowser, isWeb } from 'src/utils/platform';
import { e2ePersonaFromSearch, signInAsTestPersona, } from '../authentication/session/signInAsTestPersona';
import { ensureGuestSession, hasValidSession, } from '../authentication/session/ensureGuestSession';
import deviceInfoStorage from '../authentication/storage/device-info/storage';
import tokenStorage from '../authentication/storage/token/storage';
import userStorage from '../authentication/storage/user/storage';
import userPreferencesStorage from '../preferences/storage';
import updateUserDeviceInfo from './utils/updateDeviceInfo';
function clearSession() {
    Analytics.logout();
    graphqlClient.clearStore();
    getJSONStorage(StorageKeys.userAuthToken.scope).delete(StorageKeys.userAuthToken.key);
    getJSONStorage(StorageScope.USER).clearAll();
    bottomDrawerHelperActions.hide();
    overlayHelperViewActions.hide();
}
const appEvents = {
    addCustomDevSettings() {
        if (__DEV__ && !isWeb) {
            // ponytail: native-only API — dynamic require avoids web bundle export warning
            const DevSettings = require('react-native').DevSettings;
            if (!DevSettings)
                return;
            DevSettings.addMenuItem('Reset FTUE', () => {
                FTUEStorage.UNSAFE_clearAll();
            });
            DevSettings.addMenuItem('Clear Storage', () => {
                UNSAFE_clearAllStorages();
            });
        }
    },
    async onBoot() {
        if (__DEV__ && isBrowser && getTenancy() === Tenancy.TEST) {
            const persona = e2ePersonaFromSearch(window.location.search);
            if (persona) {
                await signInAsTestPersona(persona);
                return;
            }
        }
        if (!hasValidSession()) {
            await ensureGuestSession();
            return;
        }
        appEvents.addCustomDevSettings();
        const storedDeviceInfo = deviceInfoStorage.getDeviceInfo();
        const currentDeviceInfo = await getDeviceInfo();
        const hasChanged = !isShallowEqual(currentDeviceInfo, storedDeviceInfo);
        if (hasChanged) {
            await updateUserDeviceInfo();
        }
    },
    async onLoginSuccess(data) {
        try {
            userStorage.setUserDetails(data.userInfo);
            deviceInfoStorage.setDeviceInfo(data.deviceInfo);
            tokenStorage.setToken(data.token);
            userPreferencesStorage.setPrefs(data.preferences);
            Analytics.login(data.userInfo.id, {
                email: data.userInfo.email,
            });
            Crashlytics.login(data.userInfo.id, {
                email: data.userInfo.email,
            });
            appEvents.addCustomDevSettings();
            await updateUserDeviceInfo();
        }
        catch (error) {
            console.error('failed to save user session details:', error);
        }
    },
    // Register any logout events in here
    // so that it will called when a User is logged out
    onLogout() {
        clearSession();
        ensureGuestSession().catch(error => {
            console.error('Failed to restore guest session after logout:', error);
        });
    },
};
export default appEvents;
